import { render, staticRenderFns } from "./OnDemandViews.vue?vue&type=template&id=9ce075b8&scoped=true&"
import script from "./OnDemandViews.vue?vue&type=script&lang=js&"
export * from "./OnDemandViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce075b8",
  null
  
)

export default component.exports